<template>
    <div class="administrative-units-index">

        <div class="row">

            <div class="col-md-6">
                <map-card
                    :title="`Rwandan Administrative Units: ${typeCapitalized}`"
                    :config="mapConfig" >

                    <template slot="body">
                        <spatial-searcher
                            :target-slug="type"
                            @search="search"
                        ></spatial-searcher>
                    </template>

                </map-card>

                <div>
                    <p v-if="shouldSearchMap == false" class="alert alert-info">Search results will not be highlighted on the map due to sheer number of features.</p>
                </div>

            </div>

            <div class="col-md-6">
                <administrative-units-table
                    :button-url="currentUrl"
                    :units="filteredUnits"
                    @foundItems="(items) => { filteredItems = items }" >
                </administrative-units-table>
            </div>

        </div>

    </div>
</template>

<script>

import MapAndTable from "../mixins/MapAndTable";

import AdministrativeUnitsTable from "../administrative-units/AdministrativeUnitsTable";

import VectorLayer from 'ol/layer/vector';
import VectorSource from 'ol/source/vector';

import mapUtils from '../../src/maps/utils';

import SpatialSearcher from '../filters/AdminUnitSpatialSearcher';

export default {

    mixins:[MapAndTable],

    components: {
        "administrative-units-table": AdministrativeUnitsTable,
        "spatial-searcher": SpatialSearcher
    },

    props: {
        type: {
            type: String,
            required: true,
        },
    },

    data() {
        return {

            unitsOlLayer: new VectorLayer({
                name: this.type,
                style: ((this.type === "village") ? mapUtils.pointStyle : mapUtils.basicStyle)
            }),

            searchUnitsOlLayer: new VectorLayer({
                name: this.type + "_search",
                style: ((this.type === "village") ? mapUtils.searchedPointStyle : mapUtils.searchedStyle),
                source: new VectorSource()
            }),

            filteredUnits: this.units,
            
        };
    },

    mounted() {
        window.axios.get( window.APP_URL + "/administrative-unit/spatial/" + this.type )
            .then( (result) => {
                if (this.type === "village"){
                    this.initClusteredMapLayer(result.data);
                } else {
                    this.initBasicMapLayer(result.data);
                }
            })
            .catch( (err) => { alert("Admin units error: could not fetch spatial data for " + this.type + "s."); });
    },

    methods: {

        search(items) 
        {
            this.filteredUnits = items;
        }
    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/administrative-units/AdministrativeUnitsIndex.vue